const update = (container) => {
  const button = container.querySelector('button[type=submit]');

  let hasChange = false;
  container.querySelectorAll('input[type=checkbox]').forEach((checkbox) => {
    if (checkbox.checked !== checkbox.hasAttribute('data-checked')) {
      hasChange = true;
    }
  });

  if (hasChange) {
    button.removeAttribute('disabled');
  } else {
    button.setAttribute('disabled', true);
  }
};

document.querySelectorAll('.search-filter').forEach((container) => {
  update(container);
  container.querySelectorAll('input[type=checkbox]').forEach((checkbox) => {
    checkbox.addEventListener('change', () => { update(container); });
  });
});
